import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { CircularProgress, Stack, Typography } from "@mui/material";
import useRoutes from "@/hooks/useRoutes";

const OnboardingFinished = () => {
  const { state } = useLocation();
  const [goToUrl] = useRoutes();
  const isOther = state?.industry === "other";

  useEffect(() => {
    if (state?.organizationId) {
      const timer = setTimeout(() => {
        goToUrl("organizations.firstSteps.main", {
          organizationId: state.organizationId,
        });
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [state, goToUrl]);

  return (
    <Stack spacing={4} alignItems="center" justifyContent="center" py={4}>
      <Typography textAlign="center" variant="h2" color="white">
        ¡Listo!
      </Typography>
      <Typography textAlign="center" variant="h4" color="white">
        {isOther
          ? "Tu comercio está listo para comenzar a mostrar tus productos."
          : "Tu restaurante está listo para comenzar a recibir pedidos."}
      </Typography>

      <Stack spacing={2} alignItems="center" pt={4}>
        <CircularProgress color="secondary" size={48} />
        <Typography variant="body1" color="white" sx={{ opacity: 0.8 }}>
          Redirigiendo a tu cuenta...
        </Typography>
      </Stack>
    </Stack>
  );
};

export default OnboardingFinished;
